import {BaseContainerModel} from '../../base-container.model';
import {
  bl_cms_topic_subscription_event_RowClass,
  bl_cms_topic_subscription_ext_RowClass,
  bl_cms_topic_subscription_hdr_RowClass,
} from '../../../dbschema';

export class TopicSubscriptionContainerModel extends BaseContainerModel {
  bl_cms_topic_subscription_hdr: bl_cms_topic_subscription_hdr_RowClass = new bl_cms_topic_subscription_hdr_RowClass();
  bl_cms_topic_subscription_exts: bl_cms_topic_subscription_ext_RowClass [] = [];
  bl_cms_topic_subscription_events: bl_cms_topic_subscription_event_RowClass [] = [];
}
